// @flow
import localStorage from "../utils/local-storage";
import { getCustUrl } from "../../utils/cust";
import { fetchRest } from "../rest";

export const fetchUserInfo = async blogPassword => {
    try {
        const storedPassword = await localStorage(`bp-${getCustUrl()}`);
        const bypassPassword = storedPassword ? `stored-${storedPassword}` : "bypass";
        const params = { all: 1, blogpassword: blogPassword || bypassPassword };
        const userInfo = await fetchRest("cust", params);
        console.log({ userInfo });

        if (blogPassword && userInfo.length > 0 && userInfo[0].blogPassword === "ok") {
            localStorage(`bp-${getCustUrl()}`, blogPassword);
        }
        return userInfo;
    } catch (err) {
        err.message = `Unable to retrieve user info: ${err.message}`;
        throw err;
    }
};



// WEBPACK FOOTER //
// ./src/rest/user-context/index.js